import { Box } from '@mui/material';
import React from 'react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import TitleIcon from '@mui/icons-material/Title';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import DrawIcon from '@mui/icons-material/Draw';
import { Config, DrawAction } from './types';
import ConfigToolbar from './ConfigToolbar';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { tooltipStyle } from './utils';

interface ShapeToolBarProps {
  drawAction: DrawAction;
  setDrawAction: React.Dispatch<React.SetStateAction<DrawAction>>;
  config: Config;
  setConfig: React.Dispatch<React.SetStateAction<Config>>;
}
const ShapeToolBar: React.FC<ShapeToolBarProps> = ({
  drawAction,
  setDrawAction,
  config,
  setConfig,
}) => {
  const findStylesForActions = (currentAction: DrawAction, action: DrawAction) => {
    return {
      cursor: 'pointer',
      color: '#162936',
      fontSize: '2.5rem',
      p: '0.5rem',
      border: '1px solid #D8DBDD',
      ...(currentAction === action
        ? {
            background: '#e3e3e4d7',
            color: '#2F736E',
          }
        : {}),
    };
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '1.5rem',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            borderRadius: '8px',
            border: '1px solid #D8DBDD',
            backgroundColor: '#fff',
          }}
        >
          <CustomTooltip content={'Text'} customStyle={tooltipStyle}>
            <TitleIcon
              sx={findStylesForActions(drawAction, DrawAction.Text)}
              onClick={() => setDrawAction(DrawAction.Text)}
            />
          </CustomTooltip>
          <CustomTooltip content={'Free draw'} customStyle={tooltipStyle}>
            <DrawIcon
              sx={findStylesForActions(drawAction, DrawAction.Scribble)}
              onClick={() => setDrawAction(DrawAction.Scribble)}
            />
          </CustomTooltip>

          <CustomTooltip content={'Circle'} customStyle={tooltipStyle}>
            <PanoramaFishEyeIcon
              sx={findStylesForActions(drawAction, DrawAction.Circle)}
              onClick={() => setDrawAction(DrawAction.Circle)}
            />
          </CustomTooltip>

          <CustomTooltip content={'Rectangle'} customStyle={tooltipStyle}>
            <CropSquareIcon
              sx={findStylesForActions(drawAction, DrawAction.Rectangle)}
              onClick={() => setDrawAction(DrawAction.Rectangle)}
            />
          </CustomTooltip>

          <CustomTooltip content={'Arrow'} customStyle={tooltipStyle}>
            <ArrowRightAltIcon
              sx={findStylesForActions(drawAction, DrawAction.Arrow)}
              onClick={() => setDrawAction(DrawAction.Arrow)}
            />
          </CustomTooltip>
        </Box>
        <ConfigToolbar config={config} setConfig={setConfig} drawAction={drawAction} />
        <Box
          sx={{
            borderRadius: '8px',

            backgroundColor: '#fff',
          }}
        >
          <CustomTooltip content={'Select'} customStyle={tooltipStyle}>
            <NearMeOutlinedIcon
              sx={findStylesForActions(drawAction, DrawAction.Select)}
              onClick={() => setDrawAction(DrawAction.Select)}
            />
          </CustomTooltip>
        </Box>
      </Box>
    </>
  );
};

export default ShapeToolBar;
